import React from "react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import Main from "./pages/main";
import logo from "./assets/images/logo.jpg";
import "./assets/css/reset.css";

import { configureAmplify } from "./utils";

dayjs.extend(utc);
dayjs.extend(timezone);
console.log(`NODE_ENV: ${process.env.NODE_ENV}`);
if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}

configureAmplify();

window.dayjs = dayjs;

const authenticatorComponents = {
  SignIn: {
    Header() {
      return (
        <div className="amplify-signin-header">
          <img src={logo} alt="EonLabs logo" />
        </div>
      );
    },
  },
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Authenticator components={authenticatorComponents} hideSignUp>
    {({ signOut, user }) => (
      <BrowserRouter>
        <Switch>
          <Route path="/" exact>
            <Main signOut={signOut} />
          </Route>
          <Route path="/main">
            <Main signOut={signOut} />
          </Route>
          <Redirect to="/"></Redirect>
        </Switch>
      </BrowserRouter>
    )}
  </Authenticator>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
